import { createMachine } from 'xstate';
import { Model } from 'xstate/lib/model.types';
import { BaseContext, BaseEvent, customElement, remoteMessage } from '../../../machine';
import React from 'react';

import { AddToMobileWalletFromGlobalData } from '../ZoryveDirect.components';

const WELCOME = 'WELCOME';
const ADD_TO_MOBILE_WALLET_EXISTING = 'ADD_TO_MOBILE_WALLET_EXISTING';
const QUESTIONS = 'QUESTIONS';

export const WELCOME_REMINDER_MESSAGES = {
  WELCOME:
    'Arcutis Savings Card Program: You recently signed up for ZORYVE Direct but haven\'t filled your prescription.',
  ADD_TO_MOBILE_WALLET_EXISTING: <AddToMobileWalletFromGlobalData />,
  QUESTIONS:
    'Questions? Call 1-844-979-1288 from 6:00 am–5:00 pm PT, M–F. Text STOP to unsubscribe. Text TERMS for Terms and Conditions to 1-440-496-7983.',
};

/**
 * ZORYVE Direct Program Flow V2.0
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ZoryveDirectWelcomeReminderFlow = (
  model: Model<BaseContext, BaseEvent, void>,
  initial = WELCOME
) =>
  createMachine<BaseContext, BaseEvent>({
    id: 'ZoryveDirectWelcomeReminderFlow',
    initial: initial ?? WELCOME,
    context: model.initialContext,
    states: {
      // Welcome Message
      [WELCOME]: remoteMessage({
        id: WELCOME,
        message: WELCOME_REMINDER_MESSAGES.WELCOME,
        nextState: ADD_TO_MOBILE_WALLET_EXISTING,
      }),

      [ADD_TO_MOBILE_WALLET_EXISTING]: customElement({
        id: ADD_TO_MOBILE_WALLET_EXISTING,
        jsx: WELCOME_REMINDER_MESSAGES.ADD_TO_MOBILE_WALLET_EXISTING,
        nextState: QUESTIONS,
      }),

      [QUESTIONS]: remoteMessage({
        id: QUESTIONS,
        message: WELCOME_REMINDER_MESSAGES.QUESTIONS,
      }),
    },
  });
